import apiApp from "./index";

const token = localStorage.getItem("UserjwtToken");
const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

const switched = localStorage.getItem("switched");
const switchedSubtenant = JSON.parse(localStorage.getItem("switchedSubtenant"));
// helper: return query param if subTenantId exists
const getSubTenantIdParam = () => {
    if (decodedToken?.isMultitenancy && decodedToken?.subTenantId !== undefined) {
        const subTenantId = decodedToken?.subTenantId;
        return subTenantId ? `&subTenantId=${subTenantId}` : "";
    } else if (switched && switchedSubtenant) {
        return `&subTenantId=${switchedSubtenant?.id}`;
    }
    return "";
};

// helper: inject subTenantId into request body if exists
const injectSubTenantId = (data) => {
  if (decodedToken?.isMultitenancy && decodedToken?.subTenantId) {
    const jsonData = JSON.parse(data);
    jsonData.subTenantDTO = { id: decodedToken.subTenantId };
    return JSON.stringify(jsonData);
  }
  return data;
};

// helper: common headers with conditional tenant-login
const getHeaders = () => {
  const headers = {
    Authorization: `Bearer ${token}`,
    "x-Authorization": decodedToken?.tenantApiKey,
  };

  if (decodedToken?.roles?.includes("TENANT_ADMIN") || decodedToken?.subTenantId === undefined) {
    headers["tenant-login"] = true;
  }

  return headers;
};

const AlertsApi = {
  // Create Alerts API
  CreateAlerts: (data) => {
    data = injectSubTenantId(data);

    return apiApp
      .post(`/alerts`, data, { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // List Alerts API
  ListAlerts: (AlertPagination, page) => {
    return apiApp
      .get(
        `/alerts?page=${page}&size=${AlertPagination}&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
        { headers: getHeaders() }
      )
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // Single Alerts API
  SingleAlerts: (AlertsId) => {
    return apiApp
      .get(
        `/alerts/${AlertsId}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
        { headers: getHeaders() }
      )
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // Update Alerts API
  PutAlerts: (AlertsID, data) => {
    data = injectSubTenantId(data);

    return apiApp
      .put(`/alerts/${AlertsID}`, data, { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // Delete Alerts API
  DeleteAlerts: (AlertsID) => {
    return apiApp
      .delete(
        `/alerts/${AlertsID}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
        { headers: getHeaders() }
      )
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },
};

export default AlertsApi;
